import React from "react";
import ReactDOM from "react-dom/client";
import posthog from "posthog-js";
import { PostHogProvider } from "@posthog/react";
import "@/index.css";
import "@/i18n";
import App from "@/App";

// PostHog analytics + session replay. Guarded so preview/dev builds with empty
// secrets stay harmless. Keys are build-time CRA vars (REACT_APP_*).
const posthogKey = process.env.REACT_APP_POSTHOG_KEY?.trim();
const posthogHost = process.env.REACT_APP_POSTHOG_HOST?.trim();
const posthogEnabled = Boolean(posthogKey && posthogHost);

if (posthogEnabled) {
  posthog.init(posthogKey, {
    api_host: posthogHost,
    autocapture: true,
    capture_pageview: false,
    disable_session_recording: false,
    session_recording: {},
    person_profiles: "always",
  });
}

const tree = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  posthogEnabled ? <PostHogProvider client={posthog}>{tree}</PostHogProvider> : tree,
);
